// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Editor_header__4ohOx {
  padding-bottom: 0.625rem;
  border-bottom: 1px solid #cfcfcf;
  margin-top: -0.4375rem;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.Editor_header__4ohOx span {
  color: var(--darkGray);
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 1.25rem;
}

.Editor_empty__L4x0b {
  width: 80%;
  margin: 2.5rem auto 0 auto;
}

.Editor_label__B033p {
  font-weight: 500;
  color: var(--darkGray);
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.03em;
}

.Editor_input__-rurB,
.Editor_input__-rurB .Editor_ant-select-selector__wtTfv {
  background-color: #fbfbfb;
  border-color: #d2d2d2;
  border-radius: 0.375rem;
}

.Editor_form__xgYk3 {
  margin-top: 0;
}

.Editor_form__xgYk3 .ant-form-item {
  margin-bottom: 0.75rem;
}

.Editor_form__xgYk3 .ant-upload-select {
  width: 100%;
}

/* Section dividers */

.Editor_sectionDivider__2Wg2p {
  margin: 0.75rem 0 !important;
}

.Editor_sectionDivider__2Wg2p .ant-divider-inner-text {
  padding-left: 0;
}

.Editor_sectionTitle__l1WYW {
  font-family: BebasNeue;
  font-weight: 700;
  font-size: 0.9375rem;
  color: var(--orange);
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Image card */

.Editor_imageCard__\\+Y6ib {
  border: 1px solid #f0f0f0;
  border-radius: 0.5rem;
  padding: 0.75rem;
  background-color: #fafafa;
  margin-bottom: 0.75rem;
}

.Editor_imageCardTitle__yb4Ih {
  display: block;
  font-weight: 600;
  font-size: 0.8125rem;
  color: var(--darkGray);
  margin-bottom: 0.25rem;
}

.Editor_uploadImage__M-0VT {
  border: 1px dashed var(--orange);
  background-color: #fff;
  color: var(--orange);
  font-weight: 500;
  width: 100%;
  border-radius: 0.375rem;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
}

.Editor_uploadItem__-EIWn {
  margin-bottom: 0;
}

.Editor_uploadImage__M-0VT:hover,
.Editor_uploadImage__M-0VT:focus {
  border-color: var(--orange);
  color: var(--orange);
  background-color: var(--offRed);
}

/* Radio group */

.Editor_radioGroup__orvD6 {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

.Editor_actions__pO4e8 {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
}

/* Submit */

.Editor_submitWrap__xYE2w {
  display: flex;
  align-items: center;
  justify-content: center;
}

.Editor_itemSubmit__ryU1B {
  margin-bottom: 0;
  width: 100%;
}

.Editor_submit__ox0lf {
  width: 100%;
  border-radius: 0.375rem;
  font-weight: 600;
  font-size: 0.875rem;
  margin: 0 auto;
  text-transform: uppercase;
  letter-spacing: 0.02em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.375rem;
}

.Editor_center__dah1b {
  text-align: center;
  display: block;
  font-size: 0.75rem;
  color: var(--gray);
  margin-top: 0.25rem;
}

.Editor_imgWrap__ek10z {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}

.Editor_preview__rCpi4 {
  height: 7.5rem;
  background-color: #f5f5f5;
  margin-bottom: 0.5rem;
  border-radius: 0.375rem;
  border: 1px dashed #d9d9d9;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}

.Editor_previewWithImage__nUcyK {
  border-style: solid;
  border-color: #e8e8e8;
}

.Editor_previewImg__lVSwY {
  width: 100%;
  height: 100%;
  object-fit: cover;
  border-radius: 0.375rem;
}

.Editor_previewPlaceholder__QKN73 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.375rem;
  color: var(--gray);
}

.Editor_previewIcon__gVBV6 {
  font-size: 2rem;
  color: #d9d9d9;
}

.Editor_previewText__tAqST {
  font-size: 0.75rem;
  color: var(--gray);
}

.Editor_titleCategory__n9IC1 {
  color: var(--orange);
  display: block;
  margin-bottom: 0.9375rem;
  font-weight: 500;
  text-transform: uppercase;
}

.Editor_swtichWrap__NM\\+T3 {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 1.25rem;
}

.Editor_swtichWrap__NM\\+T3 .Editor_label__B033p {
  margin-right: 0.625rem;
}

.Editor_noMargin__hUDaD {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/frontpage/styles/Editor.module.css"],"names":[],"mappings":"AAAA;EACE,wBAAwB;EACxB,gCAAgC;EAChC,sBAAsB;EACtB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;AAChC;;AAEA;EACE,sBAAsB;EACtB,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;;EAEE,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,WAAW;AACb;;AAEA,qBAAqB;;AACrB;EACE,4BAA4B;AAC9B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,oBAAoB;EACpB,oBAAoB;EACpB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,eAAe;;AACf;EACE,yBAAyB;EACzB,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,oBAAoB;EACpB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,gCAAgC;EAChC,sBAAsB;EACtB,oBAAoB;EACpB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,gBAAgB;AAClB;;AAEA;;EAEE,2BAA2B;EAC3B,oBAAoB;EACpB,+BAA+B;AACjC;;AAEA,gBAAgB;;AAChB;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,WAAW;;AACX;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;EACzB,sBAAsB;EACtB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,kBAAkB;EAClB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,yBAAyB;EACzB,qBAAqB;EACrB,uBAAuB;EACvB,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,cAAc;EACd,wBAAwB;EACxB,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".header {\n  padding-bottom: 0.625rem;\n  border-bottom: 1px solid #cfcfcf;\n  margin-top: -0.4375rem;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n}\n\n.header span {\n  color: var(--darkGray);\n  font-family: BebasNeue;\n  font-weight: 700;\n  font-size: 1.25rem;\n}\n\n.empty {\n  width: 80%;\n  margin: 2.5rem auto 0 auto;\n}\n\n.label {\n  font-weight: 500;\n  color: var(--darkGray);\n  font-size: 0.75rem;\n  text-transform: uppercase;\n  letter-spacing: 0.03em;\n}\n\n.input,\n.input .ant-select-selector {\n  background-color: #fbfbfb;\n  border-color: #d2d2d2;\n  border-radius: 0.375rem;\n}\n\n.form {\n  margin-top: 0;\n}\n\n.form :global(.ant-form-item) {\n  margin-bottom: 0.75rem;\n}\n\n.form :global(.ant-upload-select) {\n  width: 100%;\n}\n\n/* Section dividers */\n.sectionDivider {\n  margin: 0.75rem 0 !important;\n}\n\n.sectionDivider :global(.ant-divider-inner-text) {\n  padding-left: 0;\n}\n\n.sectionTitle {\n  font-family: BebasNeue;\n  font-weight: 700;\n  font-size: 0.9375rem;\n  color: var(--orange);\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n}\n\n/* Image card */\n.imageCard {\n  border: 1px solid #f0f0f0;\n  border-radius: 0.5rem;\n  padding: 0.75rem;\n  background-color: #fafafa;\n  margin-bottom: 0.75rem;\n}\n\n.imageCardTitle {\n  display: block;\n  font-weight: 600;\n  font-size: 0.8125rem;\n  color: var(--darkGray);\n  margin-bottom: 0.25rem;\n}\n\n.uploadImage {\n  border: 1px dashed var(--orange);\n  background-color: #fff;\n  color: var(--orange);\n  font-weight: 500;\n  width: 100%;\n  border-radius: 0.375rem;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.375rem;\n}\n\n.uploadItem {\n  margin-bottom: 0;\n}\n\n.uploadImage:hover,\n.uploadImage:focus {\n  border-color: var(--orange);\n  color: var(--orange);\n  background-color: var(--offRed);\n}\n\n/* Radio group */\n.radioGroup {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n.actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n}\n\n/* Submit */\n.submitWrap {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.itemSubmit {\n  margin-bottom: 0;\n  width: 100%;\n}\n\n.submit {\n  width: 100%;\n  border-radius: 0.375rem;\n  font-weight: 600;\n  font-size: 0.875rem;\n  margin: 0 auto;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.375rem;\n}\n\n.center {\n  text-align: center;\n  display: block;\n  font-size: 0.75rem;\n  color: var(--gray);\n  margin-top: 0.25rem;\n}\n\n.imgWrap {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.preview {\n  height: 7.5rem;\n  background-color: #f5f5f5;\n  margin-bottom: 0.5rem;\n  border-radius: 0.375rem;\n  border: 1px dashed #d9d9d9;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n}\n\n.previewWithImage {\n  border-style: solid;\n  border-color: #e8e8e8;\n}\n\n.previewImg {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n  border-radius: 0.375rem;\n}\n\n.previewPlaceholder {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.375rem;\n  color: var(--gray);\n}\n\n.previewIcon {\n  font-size: 2rem;\n  color: #d9d9d9;\n}\n\n.previewText {\n  font-size: 0.75rem;\n  color: var(--gray);\n}\n\n.titleCategory {\n  color: var(--orange);\n  display: block;\n  margin-bottom: 0.9375rem;\n  font-weight: 500;\n  text-transform: uppercase;\n}\n\n.swtichWrap {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-bottom: 1.25rem;\n}\n\n.swtichWrap .label {\n  margin-right: 0.625rem;\n}\n\n.noMargin {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"header": `Editor_header__4ohOx`,
	"empty": `Editor_empty__L4x0b`,
	"label": `Editor_label__B033p`,
	"input": `Editor_input__-rurB`,
	"ant-select-selector": `Editor_ant-select-selector__wtTfv`,
	"form": `Editor_form__xgYk3`,
	"sectionDivider": `Editor_sectionDivider__2Wg2p`,
	"sectionTitle": `Editor_sectionTitle__l1WYW`,
	"imageCard": `Editor_imageCard__+Y6ib`,
	"imageCardTitle": `Editor_imageCardTitle__yb4Ih`,
	"uploadImage": `Editor_uploadImage__M-0VT`,
	"uploadItem": `Editor_uploadItem__-EIWn`,
	"radioGroup": `Editor_radioGroup__orvD6`,
	"actions": `Editor_actions__pO4e8`,
	"submitWrap": `Editor_submitWrap__xYE2w`,
	"itemSubmit": `Editor_itemSubmit__ryU1B`,
	"submit": `Editor_submit__ox0lf`,
	"center": `Editor_center__dah1b`,
	"imgWrap": `Editor_imgWrap__ek10z`,
	"preview": `Editor_preview__rCpi4`,
	"previewWithImage": `Editor_previewWithImage__nUcyK`,
	"previewImg": `Editor_previewImg__lVSwY`,
	"previewPlaceholder": `Editor_previewPlaceholder__QKN73`,
	"previewIcon": `Editor_previewIcon__gVBV6`,
	"previewText": `Editor_previewText__tAqST`,
	"titleCategory": `Editor_titleCategory__n9IC1`,
	"swtichWrap": `Editor_swtichWrap__NM+T3`,
	"noMargin": `Editor_noMargin__hUDaD`
};
export default ___CSS_LOADER_EXPORT___;
